module.exports = __webpack_public_path__ + "img/globe.52eb8306.svg";